﻿export class UserToken {
    ClientID: string = "Admin";
    ClientSecret: string = "abcXyz15s";
}